/** Human-readable text for a thrown value (ApiError, Error, rejected thunk). */
export function errMsg(e: unknown): string {
  if (e instanceof Error) return e.message;
  if (e && typeof e === "object" && "message" in e) return String(e.message);
  return String(e);
}
